export default {
  name: 'overview',
  data: function() {
    return {
      overview: {}
    }
  },
  computed: {
    landingText: function() {
      return this.$store.getters.langFile[this.$options.name]
    },
    legal: function() {
      return this.$store.getters.langFile.legal
    }
  },
  methods: {
    goToPlan: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'plan',
        params: {
          id
        }
      })
    },
    goToImprint: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'imprint',
        params: {
          id
        }
      })
    },
    headerClicked: function(route) {
      let id = this.$route.params.id
      this.$router.push({
        name: route,
        params: {
          id
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/overview/overview.js